import { DashboardNotificationType, DashboardNotificationRoute } from '@web/dashboard/types';

export const REACT_NOTIFICATION_TYPES = [
  DashboardNotificationType.shiftTaskCompleted,
  DashboardNotificationType.shiftTaskDueSoon,
  DashboardNotificationType.shiftTaskOverdue,
  DashboardNotificationType.announcementReceived,
];

export const REACT_NOTIFICATION_ROUTES = [
  DashboardNotificationRoute.clockIn,
  DashboardNotificationRoute.timeclockTimesheets,
];
